import React from "react";
import Header from "../components";
import {Grid, Box, Container, Toolbar} from "@mui/material";
import Footer from "../components/Footer";
import {useLocation} from "react-router-dom";

// @ts-ignore
const Layout = ({ children }) => {

    const location = useLocation();

    const pagesWithoutFooter = ['/'];

    const showFooter = !pagesWithoutFooter.includes(location.pathname);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <Toolbar />
            <Container
                maxWidth="lg"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    px: { xs: 2, sm: 3, md: 4 },
                    py: 4,
                }}
            >
                <Grid
                    container
                    sx={{
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: '100%',
                    }}
                >
                    {children}
                </Grid>
            </Container>

            {showFooter && <Footer />}
        </Box>
    );
};

export default Layout;